import { Auth } from '../store';

enum LocalStorageKey {
    Auth = 'Auth'
}

class LocalStore {
    clearStore = () => {
        try {
            localStorage.clear();
        } catch (error) {
            // Ignore
        }
    }

    storeAuth = (auth: Auth) => {
        try {
            localStorage.setItem(LocalStorageKey.Auth, JSON.stringify(auth));
        } catch (error) {
            // Ignore
        }
    }

    removeAuth = () => {
        try {
            localStorage.removeItem(LocalStorageKey.Auth);
        } catch (error) {
            // Ignore
        }
    }

    auth = (): Auth | null => {
        try {
            const json: string | null = localStorage.getItem(LocalStorageKey.Auth);
            if (json) {
                return JSON.parse(json);
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    }
}

const localStore = new LocalStore();

export default localStore;



// WEBPACK FOOTER //
// ./src/utils/LocalStore.ts